export default {
      id: "arrow-short-usage",
      viewBox: "0 0 22 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#arrow-short",
      toString: function () {
        return this.url;
      }
    }